import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import './App.css';
import './i18n';

import Proposal from './Structure';

import { initGA } from "./utils/analytics";
import AnalyticsTracker from "./components/AnalyticsTracker";

// --- ScrollToHash COMPONENT ---
function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }, [hash]);

  return null;
}

// --- MAIN APP COMPONENT ---
function App() {

  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router basename={process.env.PUBLIC_URL || ''}>
      <AnalyticsTracker />
      <ScrollToHash />

      <div className="App">
        <Routes>
          <Route path="/*" element={<Proposal />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;